<ng-container *ngIf="banners.length > 0 && !tokenSignPost">
    <span class="postbet-signposting-title">{{ title }}</span>
    <span class="postbet-signposting-banner" *ngFor="let banner of banners" [ngClass]="banner.cssClass">{{ banner.text }}</span>
</ng-container>
<ng-container *ngIf="tokenSignPost">
    <div class="postbet-signposting__icon-container" *ngIf="tokenSignPost.iconCssClass">
        <span class="signposting-reward-tokens-card__icon" [ngClass]="tokenSignPost.iconCssClass"></span>
    </div>
    <div class="postbet-signposting-info-reward__description" *ngIf="tokenSignPost.title">
        <div class="postbet-signposting-info-reward__award-title" [innerHtml]="tokenSignPost.title | msTrust: 'html'"></div>
        <div class="postbet-signposting-info-reward__award-description" *ngIf="tokenSignPost.description">{{ tokenSignPost.description }}</div>
    </div>
</ng-container>
